import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess40604Status: 'idle',
    startProcess40604Error: undefined as any,
    loadUserParamsProcess40604Status: 'idle',
    loadUserParamsProcess40604Error: undefined as any,

    process40604List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess40604 = createAsyncThunk('process40604Slice/startProcess40604', async ({ process40604 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess40604/`,
        prepareData(process40604),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess40604Status } = getState().process40604Slice
        return startProcess40604Status !== 'pending'
    }
})

export const loadUserParamsProcess40604 = createAsyncThunk('process40604Slice/loadUserParamsProcess40604', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess40604/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess40604Status } = getState().process40604Slice
        return loadUserParamsProcess40604Status !== 'pending'
    }
})

const Process40604Slice = createSlice({
    name: 'process40604Slice',
    initialState,
    reducers: {
        resetstartProcess40604: (state) => {
            state.job = undefined
            state.startProcess40604Error = undefined
        },
        resetstartProcess40604Error: (state) => {
            state.startProcess40604Error = undefined
        },
        resetloadUserParamsProcess40604: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess40604Error = undefined
        },
        resetloadUserParamsProcess40604Error: (state) => {
            state.loadUserParamsProcess40604Error = undefined
        },
        removeFromProcess40604ListById: (state, action) => {
            state.process40604List = state.process40604List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess40604ListByIds: (state, action) => {
            state.process40604List = state.process40604List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process40604List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess40604Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process40604List = []
            state.startProcess40604Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess40604.pending, (state) => {
            state.startProcess40604Status = 'pending'
            state.startProcess40604Error = undefined
        })
        builder.addCase(startProcess40604.fulfilled, (state, action) => {
            state.startProcess40604Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess40604.rejected, (state, action) => {
            state.startProcess40604Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess40604Error = action.error.message
            } else {
                state.startProcess40604Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess40604.pending, (state) => {
            state.loadUserParamsProcess40604Status = 'pending'
            state.loadUserParamsProcess40604Error = undefined
        })
        builder.addCase(loadUserParamsProcess40604.fulfilled, (state, action) => {
            state.loadUserParamsProcess40604Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess40604.rejected, (state, action) => {
            state.loadUserParamsProcess40604Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess40604Error = action.error.message
            } else {
                state.loadUserParamsProcess40604Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess40604,
    resetstartProcess40604Error,
    resetloadUserParamsProcess40604,
    resetloadUserParamsProcess40604Error,
    removeFromProcess40604ListById,
    removeFromProcess40604ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process40604Slice.actions
export default Process40604Slice.reducer
